import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import SpinnerCircular from './SpinnerCircular';
import { theme } from '../theme';
import { loadGoogleMapsApi } from '../utils/loadGoogleMapsApi';

const GOOGLE_MAP_LIBRARIES = ['places', 'marker'];

const GoogleMapsLoader = ({ children }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    let isCancelled = false;

    const initializeMaps = async () => {
      try {
        const maps = await loadGoogleMapsApi({
          apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
          libraries: GOOGLE_MAP_LIBRARIES,
          version: 'weekly'
        });

        await Promise.all([
          maps.importLibrary('maps'),
          maps.importLibrary('places'),
          maps.importLibrary('marker')
        ]);

        if (!isCancelled) {
          setIsLoaded(true);
        }
      } catch (error) {
        if (!isCancelled) {
          setLoadError(error);
        }
      }
    };

    initializeMaps();
    return () => {
      isCancelled = true;
    };
  }, []);

  if (loadError) {
    console.error('Error al cargar Google Maps API:', loadError);
    return <div>Error al cargar Google Maps. Por favor, intenta nuevamente.</div>;
  }

  if (!isLoaded) {
    return (
      <MapLoader>
        <MapSpinnerWrapper>
          <SpinnerCircular
            color={theme.fill.brandMain}
            secondaryColor={theme.fill.defaultWeak}
            size={32}
            speed={100}
            thickness={180}
          />
        </MapSpinnerWrapper>
      </MapLoader>
    );
  }

  return children;
};

export default GoogleMapsLoader;

const MapLoader = styled.div`
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  width: 100%;
`;

const MapSpinnerWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;
